import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import DynamicField from './dynamic-field';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(3),
  },
  input: {
    flex: 1,
  },
  gridItem: {
    display: 'flex',
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  section: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'stretch',
  },
  actions: {
    display: 'flex',
    gap: `${theme.spacing(2)}px`,
  },
  actionBtn: {
    flex: 1,
  },
}));

export type FieldType = {
  name?: string;
  type?:
    | 'text'
    | 'password'
    | 'email'
    | 'date'
    | 'select'
    | 'radio'
    | 'switch'
    | 'number'
    | 'file'
    | 'section'
    | 'input-range'
    | 'autocomplete'
    | 'checkbox'
    | 'time'
    | 'custom';

  label: string;
  initialValue?: string | number | Date | boolean | any[];
  required?: boolean;
  disabled?: boolean;
  grid?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  options?: any[];
  multiline?: boolean;
  rows?: number;
  rowsMax?: number;
  onChange?: Function;
  multiple?: boolean;
  value?: any;
  onFileSelect?: Function;
  component?: React.ReactNode;
  placeholder?: string;
};

type DynamicFieldListProps = {
  fields: { [key: string]: FieldType };
  disabled?: boolean;
};

const DynamicFieldList = ({ fields, disabled }: DynamicFieldListProps) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      {Object.keys(fields).map((fieldName) => (
        <Grid item xs={12} sm={fields[fieldName].grid} className={classes.gridItem}>
          <DynamicField
            {...fields[fieldName]}
            name={fieldName}
            className={classes.input}
            disabled={disabled || fields[fieldName].disabled}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default DynamicFieldList;
